// We had bugs in the past, where the props were mutated. Apply Object.freeze() to prevent this.
export const props = Object.freeze({
  /**
   * The current location resource encoded as a provider-search param
   * (`ProviderSearch.record_to_param(location)`). Used as the finder's `location` filter.
   * When blank the component renders nothing.
   *
   * @type {String}
   * @default undefined
   */
  locationParam: {
    type: String,
    default: undefined,
  },
  /**
   * JSON-encoded array of specialty options shaped as `{ label, value }`. Each `value` is a
   * provider-search param (`ProviderSearch.record_to_param(specialty)`) used as the finder's
   * `skill` filter. The "Any Specialty" entry has an empty `value`.
   *
   * @type {String}
   * @default "[]"
   */
  specialties: {
    type: String,
    default: "[]",
  },
  /**
   * The `department` scope for the campus the location details page is showing, auto-derived from the
   * page's selected address (sparkle-christus#316) — there is no campus dropdown. A pipe-delimited set of
   * Address `department_id`s for that campus (across the hospital's CHP/USFHP Locations), sent as the
   * finder's `department` param; the plan filter narrows it to the session plan's source system. An empty
   * string omits the `department` param, leaving the whole-hospital roster.
   *
   * @type {String}
   * @default ""
   */
  department: {
    type: String,
    default: "",
  },
  /**
   * Path to the doctor finder that the Search button navigates to.
   *
   * @type {String}
   * @default "/physicians"
   */
  finderPath: {
    type: String,
    default: "/physicians",
  },
  /**
   * The `distance` the search sends to the finder. Defaults to the finder's "any" (no-radius)
   * sentinel so a persisted/URL radius can't truncate the roster (sparkle-christus#314). A directory
   * that has dropped its "Any Distance" option has no "any" to send, so it passes its largest
   * configured radius instead (sparkle-christus#307).
   *
   * @type {String}
   * @default "any"
   */
  searchDistance: {
    type: String,
    default: "any",
  },
});
